export const GetReports = async () => {
  const response = await fetch(`DeliveryStatusReport/GetReport`);
  return await response.json();
};

export default {
  GetReports,
};
